import {
    Box,
    Input,
    Button,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody, AlertDialogFooter, AlertDialog, useDisclosure, useToast,
    VStack
} from "@chakra-ui/react";
import {gql, useClient, useMutation} from "@apollo/client";
import React, {useRef, useState} from "react"

const insertNewThemeMutation = gql`
mutation InsertNewThemeAndTopic($customer: String = "", $description: String = "", $query: String = "", $data: jsonb = "", $topic_name: String = "", $enabled: Boolean = true, $theme_name: String = "", $type: String = "", $semantic_search_results: [semantic_search_results_insert_input!] = {}) {
  insert_themes_one(object: {topics: {data: {topic_definitions: {data: {data: $data, query: $query, type: $type, semantic_search_results: {data: $semantic_search_results}}}, customer: $customer, topic_name: $topic_name}}, customer: $customer, description: $description, enabled: $enabled, theme_name: $theme_name}) {
    timestamp_created
    topics {
      topic_definitions {
        topic_definition_id
      }
    }
  }
}
`


export function NewThemeForm({query, resultsLength, searchResults, searchThreshold, topk}) {
    const [mutateNewThemeFunction, {
        data: mutationNewData,
        loading: mutationNewLoading,
        error: mutationNewError
    }] = useMutation(insertNewThemeMutation);
    const [themeName, setThemeName] = useState("");
    const [themeDescription, setThemeDescription] = useState("");
    const [topicName, setTopicName] = useState("");
    const {isOpen, onOpen, onClose} = useDisclosure()
    const cancelRef = useRef()
    const toast = useToast()

    function updateThemeDialog() {
        if (!query) {
            toast({description: 'Search Query cannot be empty'})
            return
        }
        onOpen()
    }

    function submitNewTheme() {
        mutateNewThemeFunction({
            variables: {
                customer: localStorage.getItem("customerName"),
                description: themeDescription,
                query: query,
                data: {
                    "topk": topk,
                    "threshold": searchThreshold,
                },
                topic_name: topicName,
                enabled: true,
                theme_name: themeName,
                type: "semantic_search",
                semantic_search_results: searchResults.map((result) => ({
                    text_id: result.text_id, score: result.data["cross-score"]
                }))
            }
        }).then((data) => {
            console.log("mutationData", data)
            console.log("topic_definition_id", data.data.insert_themes_one.topics[0].topic_definitions[0].topic_definition_id)
            let topicdefid = data.data.insert_themes_one.topics[0].topic_definitions[0].topic_definition_id
            toast({description: `New theme successfully created`})
            fetch(`${process.env.REACT_APP_API_URL}/inferSemanticSentiment?topicdefid=${topicdefid}`)
                .then((response) => console.log("SUCCESSFULLY SENT REQUEST TO INFER SENTIMENT", response))
                .catch((error) => console.log("ERROR WHILE SENDING REQUEST TO INFER SENTIMENT", error))
        }).catch((error) => {
            toast({description: `Error while creating new theme. Please try again`})
            console.log(error, mutationNewError)
        })

        onClose()
    }

    return (
        <>
            <VStack>
                <Input placeholder="Theme Name" bg='#FFFFFF' borderRadius='10px' w="400px" mt="10px"
                       onChange={(e) => setThemeName(e.target.value)} value={themeName}/>
                <Input placeholder="Theme Description" bg='#FFFFFF' borderRadius='10px' w="400px" mt="10px"
                       onChange={(e) => setThemeDescription(e.target.value)} value={themeDescription}/>
                <Input placeholder="Topic name" bg='#FFFFFF' borderRadius='10px' w="400px" mt="10px"
                       onChange={(e) => setTopicName(e.target.value)} value={topicName}/>
                <Box mt="10px">
                    <Button mr="10px" onClick={() => updateThemeDialog()}
                            isDisabled={themeName === "" || themeDescription === "" || topicName === ""}>Save</Button>
                    <Button onClick={() => {
                        setThemeName("");
                        setThemeDescription("");
                        setTopicName("");
                    }}>Cancel</Button>
                </Box>
            </VStack>
            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Confirm Save?
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            This will create a new theme {themeName} and a topic {topicName} with the query "{query}"
                            that matched {resultsLength} results with threshold
                            of {searchThreshold}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                onClick={submitNewTheme}
                                ml={3}>
                                Confirm
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}